// Modernes Contact Widget mit konfigurierbaren Einstellungen
const ModernContactWidget = {
    // Konfiguration - Hier kannst du Seiten ausschließen
    config: {
        // Seiten auf denen das Widget NICHT angezeigt werden soll
        excludedPages: [
            '/checkout',
            '/cart',
            '/admin',
            '/account/login',
            '/account/register'
        ],
        // Weitere URLs können hier einfach hinzugefügt werden
        excludedUrls: [
            // 'https://deinshop.de/spezielle-seite'
        ],
        showDelay: 1000, // Widget erscheint nach 1 Sekunde
        scrollThreshold: 100 // oder nach 100px scrollen
    },

    init() {
        const widget = document.querySelector('.modern-contact-widget');
        if (!widget) return;

        // Prüfe ob aktuelle Seite ausgeschlossen ist
        if (this.shouldHideOnCurrentPage()) {
            widget.remove();
            return;
        }

        // Setup
        this.widget = widget;
        this.button = widget.querySelector('.contact-main-btn');
        this.menu = widget.querySelector('.contact-menu');
        this.iconClosed = widget.querySelector('.icon-closed');
        this.iconOpen = widget.querySelector('.icon-open');
        
        this.isOpen = false;
        this.hasAppeared = false;

        // Event Listeners
        this.setupEventListeners();
        
        // Sanftes Einblenden nach Delay oder Scroll
        this.setupAppearance();
    },

    shouldHideOnCurrentPage() {
        const currentPath = window.location.pathname;
        const currentUrl = window.location.href;

        // Prüfe excluded Pages
        for (let page of this.config.excludedPages) {
            if (currentPath.includes(page)) {
                return true;
            }
        }

        // Prüfe excluded URLs
        for (let url of this.config.excludedUrls) {
            if (currentUrl.includes(url)) {
                return true;
            }
        }

        return false;
    },

    setupEventListeners() {
        // Hauptbutton Click
        this.button.addEventListener('click', () => this.toggle());

        // Außerhalb klicken schließt Menü
        document.addEventListener('click', (e) => {
            if (!this.widget.contains(e.target) && this.isOpen) {
                this.close();
            }
        });

        // ESC Taste schließt Menü
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }
        });
    },

    setupAppearance() {
        // Initial versteckt
        this.widget.style.opacity = '0';
        this.widget.style.transform = 'scale(0.8)';

        // Erscheinen nach Verzögerung
        setTimeout(() => {
            this.appear();
        }, this.config.showDelay);

        // Oder erscheinen beim Scrollen
        let scrollHandler = () => {
            if (window.scrollY > this.config.scrollThreshold && !this.hasAppeared) {
                this.appear();
                window.removeEventListener('scroll', scrollHandler);
            }
        };
        window.addEventListener('scroll', scrollHandler, { passive: true });
    },

    appear() {
        if (this.hasAppeared) return;
        
        this.widget.style.opacity = '1';
        this.widget.style.transform = 'scale(1)';
        this.hasAppeared = true;
    },

    toggle() {
        this.isOpen ? this.close() : this.open();
    },

    open() {
        this.isOpen = true;
        this.widget.classList.add('is-open');
        this.menu.setAttribute('aria-hidden', 'false');
        this.button.setAttribute('aria-expanded', 'true');
        
        // Icons wechseln
        this.iconClosed.style.display = 'none';
        this.iconOpen.style.display = 'block';
    },

    close() {
        this.isOpen = false;
        this.widget.classList.remove('is-open');
        this.menu.setAttribute('aria-hidden', 'true');
        this.button.setAttribute('aria-expanded', 'false');
        
        // Icons wechseln
        this.iconClosed.style.display = 'block';
        this.iconOpen.style.display = 'none';
    },

    openBooking() {
        // Deine Booking-URL hier
        window.open('https://calendly.com/deine-booking-url', '_blank');
    }
};

// Initialisieren wenn DOM bereit
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ModernContactWidget.init());
} else {
    ModernContactWidget.init();
}